import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import { getHostingURL } from 'utils';
import { startEditWebsiteRoot } from 'store/actions/website';

const styles = theme => ({
  root: {

  }
});

class PurchaseDomainDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchDomain: '',
      domains: []
    }
  }

  queryDomains() {
    const { searchDomain } = this.state;
    const hostingURL = getHostingURL();

    fetch(`${hostingURL}/queryDomains?query=${searchDomain}&token=LaST18dswfD37VCwVjSsgiselDIDqwwq18iXTvRv`, {
      mode: 'cors',
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    })
    .then(response => response.json())
    .then(result => {
      console.log("DOMAINS IN FETCH:", result.domains);
      this.setState({ domains: result.domains });
      //console.log("DOMAINS:", domains);
    })
    .catch(error => {
      console.log("ERROR:", error);
    });
  }

  render() {
    const {
      showDialog,
      handleClose,
      startEditWebsiteRoot
    } = this.props;
    const { searchDomain, domains } = this.state;
    //console.log("DOMAINS STATE:", domains);

    return(
      <Dialog
        open={showDialog}
        onClose={handleClose}
      >
        <DialogTitle>
          Purchase Custom Domain
        </DialogTitle>
        <DialogContent>
          <div>
            <TextField
              label="Search domains"
              onChange={ event => {
                this.setState({ searchDomain: event.target.value });
              }}
            />
            <Button
              onClick={this.queryDomains.bind(this)}
            >
              Search
            </Button>
            {domains.map(domain => {
              let price;
              if(domain.isVerified) {
                price = domain.available ? `$${domain.price}/yr` : "unavailable";
              } else {
                price = "unverfied";
              }

              return (
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                  <Typography style={{ width: '400px' }}>
                    {domain.domain}
                  </Typography>
                  <Typography>
                    {domain.available ? `$${domain.price}/yr` : "unavailable" }
                  </Typography>
                  <Button
                    onClick={() => {
                      const hostingURL = getHostingURL();

                      console.log("DOMAIN:", domain);
                      fetch(`${hostingURL}/purchaseDomain`, {
                        mode: 'cors',
                        method: 'POST',
                        headers: {
                          'Accept': 'application/json',
                          'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                          domain,
                          token: "LaST18dswfD37VCwVjSsgiselDIDqwwq18iXTvRv"
                        })
                      })
                      .then(response => response.json())
                      .then(result => {
                        console.log("PURCHASE RESULT:", result);
                        if (result.confirmed) {
                          startEditWebsiteRoot({ customDomain: result.domain.domain });
                          handleClose();
                        }

                      })
                      .catch(error => {
                        console.log("ERROR:", error);
                      });
                    }}
                  >
                    Purchase
                  </Button>
                </div>
              )
            })}
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToProps = {
  startEditWebsiteRoot,
};

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps)
)(PurchaseDomainDialog);



// WEBPACK FOOTER //
// ./src/components/admin/Website/Dialogs/PurchaseDomainDialog.jsx